import { useTranslation } from 'react-i18next'
import { House, RotateCw, UserRound } from 'lucide-react'
import { usePrescriptionExitToStart, usePrescriptionFlowSend } from '../context'
import { KioskStep } from '../../../../../components/kiosk-step'
import { KioskStatePanel } from '../../../../../components/kiosk-state-panel'
import { useAudio } from '../../../../../lib/use-audio'

/**
 * No patient found step — one content-sized state panel with two normal
 * buttons instead of two hero tiles (KO-85, KO-16): try again, or leave for
 * the hub. The footer "Zurück" is hidden here; "Erneut versuchen" is the way
 * back.
 *
 * @since 1.0.0
 * @example
 * ```tsx
 * <NoPatientFoundStep />
 * ```
 */
export function NoPatientFoundStep() {
  const { t } = useTranslation()
  useAudio('prescription-noPatientFound')
  const send = usePrescriptionFlowSend()
  const exitToStart = usePrescriptionExitToStart()

  return (
    <KioskStep width="narrow" align="center" title={t('self-service.prescription.no-patient.title-v2')}>
      <KioskStatePanel
        tone="warning"
        testId="frontdesk-prescription-no-patient-panel"
        icon={<UserRound />}
        title={t('self-service.prescription.no-patient.title-v2')}
        body={t('self-service.prescription.no-patient.subtitle-v2')}
        action={{
          label: t('self-service.prescription.no-patient.try-again'),
          icon: RotateCw,
          onClick: () => send({ type: 'BACK' }),
          testId: 'frontdesk-prescription-no-patient-retry-btn',
        }}
        secondaryAction={{
          label: t('self-service.prescription.no-patient.back-home'),
          icon: House,
          onClick: exitToStart,
          testId: 'frontdesk-prescription-no-patient-home-btn',
        }}
      />
    </KioskStep>
  )
}
